import * as React from 'react'

// this is a huge hack until we get some configurable timeline component
export const generateProgress = progress => {
  switch (progress) {
    case 1:
      return progress1()
    case 2:
      return progress2()
    case 3:
      return progress3()
    case 4:
      return progress4()
    case 5:
      return progress5()
    default:
      return progress1()
  }
}

function progress1() {
  return (
    <svg
      width={243}
      height={25}
      viewBox="0 0 243 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M242 12.5a1.5 1.5 0 01-1.5 1.5H4.5a1.5 1.5 0 010-3h236a1.5 1.5 0 011.5 1.5z"
        fill="#E7E7E7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41 12.5a1.5 1.5 0 01-1.5 1.5h-35a1.5 1.5 0 010-3h35a1.5 1.5 0 011.5 1.5z"
        fill="#191919"
      />
      <circle cx={121.376} cy={12.035} r={12.035} fill="#E7E7E7" />
      <path
        d="M122.722 12.195s1.1-.44 1.1-1.65c0-1.177-.99-2.145-2.585-2.145-1.815 0-2.64 1.155-2.64 1.155l.99.99s.55-.715 1.485-.715c.66 0 1.045.385 1.045.88 0 .55-.385.935-1.045.935h-.77v1.375h.825c.825 0 1.265.44 1.265.99s-.44.99-1.32.99c-1.122 0-1.76-.825-1.76-.825l-.99 1.045s.935 1.21 2.915 1.21c1.782 0 2.86-1.1 2.86-2.31 0-1.485-1.375-1.925-1.375-1.925z"
        fill="#494949"
      />
      <circle cx={66.706} cy={12.035} r={12.035} fill="#E7E7E7" />
      <circle cx={12.035} cy={12.035} r={12.035} fill="#191919" />
      <path
        d="M69.29 16.265v-1.54h-3.3c.88-1.375 3.3-1.76 3.3-3.85 0-1.375-1.1-2.475-2.695-2.475-2.145 0-2.695 1.815-2.695 1.815l1.375.66s.275-.935 1.21-.935c.715 0 1.1.385 1.1.99 0 1.705-3.685 1.705-3.685 5.335h5.39z"
        fill="#494949"
      />
      <path
        d="M11.868 8.565s-.33.88-1.595 1.045v1.045h1.32v5.61h1.65v-7.7h-1.375z"
        fill="#fff"
      />
      <circle cx={230.717} cy={12.035} r={12.035} fill="#E7E7E7" />
      <path
        d="M230.67 11.15c-.77 0-1.21.275-1.21.275l.11-1.43h3.19v-1.43h-4.675l-.275 4.4 1.155.11s.385-.605 1.265-.605c.77 0 1.32.55 1.32 1.265 0 .715-.495 1.21-1.32 1.21-1.1 0-1.76-.77-1.76-.77l-.99 1.045s.88 1.21 2.86 1.21c1.76 0 2.915-1.155 2.915-2.695 0-1.485-1.1-2.585-2.585-2.585z"
        fill="#494949"
      />
      <circle cx={176.047} cy={12.035} r={12.035} fill="#E7E7E7" />
      <path
        d="M178.3 13.46V8.565h-1.925l-3.355 4.675v1.65h3.63v1.375h1.65V14.89h.88v-1.43h-.88zm-1.65 0h-2.09l2.09-2.97v2.97z"
        fill="#494949"
      />
    </svg>
  )
}

function progress2() {
  return (
    <svg
      width={243}
      height={25}
      viewBox="0 0 243 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M242 12.5a1.5 1.5 0 01-1.5 1.5H4.5a1.5 1.5 0 010-3h236a1.5 1.5 0 011.5 1.5z"
        fill="#E7E7E7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96 12.5a1.5 1.5 0 01-1.5 1.5h-90a1.5 1.5 0 010-3h90a1.5 1.5 0 011.5 1.5z"
        fill="#191919"
      />
      <circle cx={121.376} cy={12.035} r={12.035} fill="#E7E7E7" />
      <path
        d="M122.722 12.195s1.1-.44 1.1-1.65c0-1.177-.99-2.145-2.585-2.145-1.815 0-2.64 1.155-2.64 1.155l.99.99s.55-.715 1.485-.715c.66 0 1.045.385 1.045.88 0 .55-.385.935-1.045.935h-.77v1.375h.825c.825 0 1.265.44 1.265.99s-.44.99-1.32.99c-1.122 0-1.76-.825-1.76-.825l-.99 1.045s.935 1.21 2.915 1.21c1.782 0 2.86-1.1 2.86-2.31 0-1.485-1.375-1.925-1.375-1.925z"
        fill="#494949"
      />
      <circle cx={66.706} cy={12.035} r={12.035} fill="#191919" />
      <circle cx={12.035} cy={12.035} r={12.035} fill="#191919" />
      <path
        d="M69.29 16.265v-1.54h-3.3c.88-1.375 3.3-1.76 3.3-3.85 0-1.375-1.1-2.475-2.695-2.475-2.145 0-2.695 1.815-2.695 1.815l1.375.66s.275-.935 1.21-.935c.715 0 1.1.385 1.1.99 0 1.705-3.685 1.705-3.685 5.335h5.39zM11.868 8.565s-.33.88-1.595 1.045v1.045h1.32v5.61h1.65v-7.7h-1.375z"
        fill="#fff"
      />
      <circle cx={230.717} cy={12.035} r={12.035} fill="#E7E7E7" />
      <path
        d="M230.67 11.15c-.77 0-1.21.275-1.21.275l.11-1.43h3.19v-1.43h-4.675l-.275 4.4 1.155.11s.385-.605 1.265-.605c.77 0 1.32.55 1.32 1.265 0 .715-.495 1.21-1.32 1.21-1.1 0-1.76-.77-1.76-.77l-.99 1.045s.88 1.21 2.86 1.21c1.76 0 2.915-1.155 2.915-2.695 0-1.485-1.1-2.585-2.585-2.585z"
        fill="#494949"
      />
      <circle cx={176.047} cy={12.035} r={12.035} fill="#E7E7E7" />
      <path
        d="M178.3 13.46V8.565h-1.925l-3.355 4.675v1.65h3.63v1.375h1.65V14.89h.88v-1.43h-.88zm-1.65 0h-2.09l2.09-2.97v2.97z"
        fill="#494949"
      />
    </svg>
  )
}

function progress3() {
  return (
    <svg
      width={243}
      height={25}
      viewBox="0 0 243 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M242 12.5a1.5 1.5 0 01-1.5 1.5H4.5a1.5 1.5 0 010-3h236a1.5 1.5 0 011.5 1.5z"
        fill="#E7E7E7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M150 12.5a1.5 1.5 0 01-1.5 1.5H4.5a1.5 1.5 0 010-3h144a1.5 1.5 0 011.5 1.5z"
        fill="#191919"
      />
      <circle cx={121.376} cy={12.035} r={12.035} fill="#191919" />
      <path
        d="M122.722 12.195s1.1-.44 1.1-1.65c0-1.177-.99-2.145-2.585-2.145-1.815 0-2.64 1.155-2.64 1.155l.99.99s.55-.715 1.485-.715c.66 0 1.045.385 1.045.88 0 .55-.385.935-1.045.935h-.77v1.375h.825c.825 0 1.265.44 1.265.99s-.44.99-1.32.99c-1.122 0-1.76-.825-1.76-.825l-.99 1.045s.935 1.21 2.915 1.21c1.782 0 2.86-1.1 2.86-2.31 0-1.485-1.375-1.925-1.375-1.925z"
        fill="#fff"
      />
      <circle cx={66.706} cy={12.035} r={12.035} fill="#191919" />
      <circle cx={12.035} cy={12.035} r={12.035} fill="#191919" />
      <path
        d="M69.29 16.265v-1.54h-3.3c.88-1.375 3.3-1.76 3.3-3.85 0-1.375-1.1-2.475-2.695-2.475-2.145 0-2.695 1.815-2.695 1.815l1.375.66s.275-.935 1.21-.935c.715 0 1.1.385 1.1.99 0 1.705-3.685 1.705-3.685 5.335h5.39zM11.868 8.565s-.33.88-1.595 1.045v1.045h1.32v5.61h1.65v-7.7h-1.375z"
        fill="#fff"
      />
      <circle cx={230.717} cy={12.035} r={12.035} fill="#E7E7E7" />
      <path
        d="M230.67 11.15c-.77 0-1.21.275-1.21.275l.11-1.43h3.19v-1.43h-4.675l-.275 4.4 1.155.11s.385-.605 1.265-.605c.77 0 1.32.55 1.32 1.265 0 .715-.495 1.21-1.32 1.21-1.1 0-1.76-.77-1.76-.77l-.99 1.045s.88 1.21 2.86 1.21c1.76 0 2.915-1.155 2.915-2.695 0-1.485-1.1-2.585-2.585-2.585z"
        fill="#494949"
      />
      <circle cx={176.047} cy={12.035} r={12.035} fill="#E7E7E7" />
      <path
        d="M178.3 13.46V8.565h-1.925l-3.355 4.675v1.65h3.63v1.375h1.65V14.89h.88v-1.43h-.88zm-1.65 0h-2.09l2.09-2.97v2.97z"
        fill="#494949"
      />
    </svg>
  )
}

function progress4() {
  return (
    <svg
      width={243}
      height={25}
      viewBox="0 0 243 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M242 12.5a1.5 1.5 0 01-1.5 1.5H4.5a1.5 1.5 0 010-3h236a1.5 1.5 0 011.5 1.5z"
        fill="#E7E7E7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M204 12.5a1.5 1.5 0 01-1.5 1.5H4.5a1.5 1.5 0 010-3h198a1.5 1.5 0 011.5 1.5z"
        fill="#191919"
      />
      <circle cx={121.376} cy={12.035} r={12.035} fill="#191919" />
      <path
        d="M122.722 12.195s1.1-.44 1.1-1.65c0-1.177-.99-2.145-2.585-2.145-1.815 0-2.64 1.155-2.64 1.155l.99.99s.55-.715 1.485-.715c.66 0 1.045.385 1.045.88 0 .55-.385.935-1.045.935h-.77v1.375h.825c.825 0 1.265.44 1.265.99s-.44.99-1.32.99c-1.122 0-1.76-.825-1.76-.825l-.99 1.045s.935 1.21 2.915 1.21c1.782 0 2.86-1.1 2.86-2.31 0-1.485-1.375-1.925-1.375-1.925z"
        fill="#fff"
      />
      <circle cx={66.706} cy={12.035} r={12.035} fill="#191919" />
      <circle cx={12.035} cy={12.035} r={12.035} fill="#191919" />
      <path
        d="M69.29 16.265v-1.54h-3.3c.88-1.375 3.3-1.76 3.3-3.85 0-1.375-1.1-2.475-2.695-2.475-2.145 0-2.695 1.815-2.695 1.815l1.375.66s.275-.935 1.21-.935c.715 0 1.1.385 1.1.99 0 1.705-3.685 1.705-3.685 5.335h5.39zM11.868 8.565s-.33.88-1.595 1.045v1.045h1.32v5.61h1.65v-7.7h-1.375z"
        fill="#fff"
      />
      <circle cx={230.717} cy={12.035} r={12.035} fill="#E7E7E7" />
      <path
        d="M230.67 11.15c-.77 0-1.21.275-1.21.275l.11-1.43h3.19v-1.43h-4.675l-.275 4.4 1.155.11s.385-.605 1.265-.605c.77 0 1.32.55 1.32 1.265 0 .715-.495 1.21-1.32 1.21-1.1 0-1.76-.77-1.76-.77l-.99 1.045s.88 1.21 2.86 1.21c1.76 0 2.915-1.155 2.915-2.695 0-1.485-1.1-2.585-2.585-2.585z"
        fill="#494949"
      />
      <circle cx={176.047} cy={12.035} r={12.035} fill="#191919" />
      <path
        d="M178.3 13.46V8.565h-1.925l-3.355 4.675v1.65h3.63v1.375h1.65V14.89h.88v-1.43h-.88zm-1.65 0h-2.09l2.09-2.97v2.97z"
        fill="#fff"
      />
    </svg>
  )
}

function progress5() {
  return (
    <svg
      width={243}
      height={25}
      viewBox="0 0 243 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M242 12.5a1.5 1.5 0 01-1.5 1.5H4.5a1.5 1.5 0 010-3h236a1.5 1.5 0 011.5 1.5z"
        fill="#E7E7E7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M231 12.5a1.5 1.5 0 01-1.5 1.5H4.5a1.5 1.5 0 010-3h225a1.5 1.5 0 011.5 1.5z"
        fill="#191919"
      />
      <circle cx={121.376} cy={12.035} r={12.035} fill="#191919" />
      <path
        d="M122.722 12.195s1.1-.44 1.1-1.65c0-1.177-.99-2.145-2.585-2.145-1.815 0-2.64 1.155-2.64 1.155l.99.99s.55-.715 1.485-.715c.66 0 1.045.385 1.045.88 0 .55-.385.935-1.045.935h-.77v1.375h.825c.825 0 1.265.44 1.265.99s-.44.99-1.32.99c-1.122 0-1.76-.825-1.76-.825l-.99 1.045s.935 1.21 2.915 1.21c1.782 0 2.86-1.1 2.86-2.31 0-1.485-1.375-1.925-1.375-1.925z"
        fill="#fff"
      />
      <circle cx={66.705} cy={12.035} r={12.035} fill="#191919" />
      <circle cx={12.035} cy={12.035} r={12.035} fill="#191919" />
      <path
        d="M69.29 16.265v-1.54h-3.3c.88-1.375 3.3-1.76 3.3-3.85 0-1.375-1.1-2.475-2.695-2.475-2.145 0-2.695 1.815-2.695 1.815l1.375.66s.275-.935 1.21-.935c.715 0 1.1.385 1.1.99 0 1.705-3.685 1.705-3.685 5.335h5.39zM11.868 8.565s-.33.88-1.595 1.045v1.045h1.32v5.61h1.65v-7.7h-1.375z"
        fill="#fff"
      />
      <circle cx={230.717} cy={12.035} r={12.035} fill="#191919" />
      <path
        d="M230.67 11.15c-.77 0-1.21.275-1.21.275l.11-1.43h3.19v-1.43h-4.675l-.275 4.4 1.155.11s.385-.605 1.265-.605c.77 0 1.32.55 1.32 1.265 0 .715-.495 1.21-1.32 1.21-1.1 0-1.76-.77-1.76-.77l-.99 1.045s.88 1.21 2.86 1.21c1.76 0 2.915-1.155 2.915-2.695 0-1.485-1.1-2.585-2.585-2.585z"
        fill="#fff"
      />
      <circle cx={176.047} cy={12.035} r={12.035} fill="#191919" />
      <path
        d="M178.3 13.46V8.565h-1.925l-3.355 4.675v1.65h3.63v1.375h1.65V14.89h.88v-1.43h-.88zm-1.65 0h-2.09l2.09-2.97v2.97z"
        fill="#fff"
      />
    </svg>
  )
}
